export const viewType = {
  SIMPLE: 'simple',
  CUSTOM: 'custom'
};

export default {};
